import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "c-textbox" }
const _hoisted_2 = {
  key: 0,
  class: "c-textbox-label"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "c-textbox-error" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeTextarea = _resolveComponent("PrimeTextarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_PrimeTextarea, {
      ref: "inputTextarea",
      modelValue: _ctx.data,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data) = $event)),
      cols: "30",
      placeholder: _ctx.placeholder,
      "auto-resize": _ctx.autoResize,
      rows: _ctx.maxRows,
      disabled: _ctx.disabled,
      onInput: _ctx.onInput
    }, null, 8, ["modelValue", "placeholder", "auto-resize", "rows", "disabled", "onInput"]),
    _hoisted_3
  ]))
}